import { hot } from 'react-hot-loader/root';
import React from 'react';
import NotificationProvider from 'providers/NotificationProvider/NotificationProvider';
import StoreProvider from 'providers/StoreProvider/StoreProvider';
import RouterProvider from 'providers/RouterProvider/RouterProvider';
import ThemeProvider from 'providers/ThemeProvider/ThemeProvider';
import Routes from 'components/Router/Routes/Routes';
import AuthProvider from 'providers/AuthProvider/SessionAuthProvider';
import AuthIoProvider from 'providers/AuthProvider/AuthIoProvider';
import ErrorCatcher from 'providers/ErrorCatcher/ErrorCatcher';
import { history } from 'consts/routes';
import PostHogPageViewTracker from 'PostHogPageViewTracker';

interface AppStateType {
  targetUrl?: string;
}

const onRedirectCallback = (appState?: AppStateType | undefined) => {
  history.push(
    appState && appState.targetUrl
      ? appState.targetUrl
      : window.location.pathname
  );
};
const App: React.FC = () => {
  return (
    <AuthProvider onRedirectCallback={onRedirectCallback}>
      <StoreProvider>
        <AuthIoProvider>
          <NotificationProvider />
          <ThemeProvider>
            <RouterProvider>
              <ErrorCatcher>
                <PostHogPageViewTracker />
                <Routes />
              </ErrorCatcher>
            </RouterProvider>
          </ThemeProvider>
        </AuthIoProvider>
      </StoreProvider>
    </AuthProvider>
  );
};

export default hot(App);
